import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";
import { ChangePinCodeComponent, ChangePinCodeState } from "./change-pin-code.component";

@Injectable()
export class ChangePinCodeModal {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	async show(properties: ChangePinCodeModalProperties = null): Promise<void> {
		const modal = await this.modalController.create({
			id: "change-pin-modal",
			component: ChangePinCodeComponent,
			componentProps: {
				currentPin: properties?.currentPin || "",
				state: properties?.requireCurrentPin ? ChangePinCodeState.EnterCurrent : ChangePinCodeState.ChooseNew,
			},
			cssClass: this.rideOpsUi.isV2Active() ? "change-pin-modal-v2" : undefined,
		});

		await modal.present();
		await modal.onDidDismiss();
	}
}

export interface ChangePinCodeModalProperties {
	currentPin?: string;
	requireCurrentPin: boolean;
}
